<template>
  <main class="page pto">
    <AppBack />

    <AppPageHeader title="Доплата ФОТ" />

    <section class="section page__content">
      <ThePagePreloader
        v-if="isLoading"
        position="component"
      />

      <div v-if="!isEdit && !isLoading" class="info">
        <PTOProjectTitle />

        <AppButtonSmEdit
          v-if="$store.getters.rightsPtoAll"
          class="info__btn-edit"
          title="Редактировать"
          @click.native="toggleIsEdit"
        />

        <ul class="info__list-edit">
          <PtoInfoListItem
            label-text="Тип доплаты"
            :text="currentItem.surcharge_type ? currentItem.surcharge_type.surcharge_type : '-'"
          />

          <PtoInfoListItem
            label-text="Объем"
            :text="currentItem.volume ? priceFormat(currentItem.volume) : '-'"
          />

          <PtoInfoListItem
            label-text="Цена"
            :text="currentItem.surcharge_type ? priceFormat(currentItem.surcharge_type.price) : '-'"
          />
        </ul>
      </div>

      <FormPtoProjectFotProduction
        v-if="isEdit"
        :form-data="currentItem"
        is-edit
        :is-sending="isSendingRequest"
        @request="sendPutRequest"
        @cancel="toggleIsEdit"
      />
    </section>
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack.vue'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppPageHeader from '@/components/page/AppPageHeader'
import FormPtoProjectFotProduction from '@/components/pto/form/FormPtoProjectFotProduction'
import PtoInfoListItem from '@/components/pto/listItem/PtoInfoListItem'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import ThePagePreloader from '@/components/page/ThePagePreloader'

import { MIXIN_PTO_PROJECT_PAGE_UPDATE } from '@/mixins/module/pto/project/mixinPTOPageUpdate'
import { priceFormat } from '@/utils/form/priceFormat'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PtoProjectFotProductionUpdate',
  components: {
    AppBack,
    AppButtonSmEdit,
    AppPageHeader,
    FormPtoProjectFotProduction,
    PtoInfoListItem,
    PTOProjectTitle,
    ThePagePreloader
  },
  mixins: [
    MIXIN_PTO_PROJECT_PAGE_UPDATE
  ],
  data: () => ({
    handbooks: ['FotSurcharges']
  }),
  computed: {
    ...mapGetters('pto/project/estimate/fotProduction', {
      currentItem: 'getCurrentItem',
      isLoading: 'getIsLoading'
    }),
    initFilter () {
      return {
        work_sign_id: this.$route.params.id
      }
    }
  },
  methods: {
    ...mapActions('pto/project/estimate/fotProduction', {
      loadOneItem: 'loadOneItem',
      updateItem: 'updateItem'
    }),
    priceFormat
  }
}
</script>
